import { clsx } from 'clsx';
import { type FC, type PropsWithChildren } from 'react';

import { type TListingLayoutGridType } from '../../types/gridType';

import './CardListLayout.css';

interface ICardListLayoutProps {
  isNarrow?: boolean;
  gridType?: TListingLayoutGridType;
  dataTestId?: string;
  className?: string;
}

const GRID_TYPE_TO_CLASS_NAME = {
  oneColumn: 'one-column',
  twoColumns: 'two-columns',
};

export const CardListLayout: FC<PropsWithChildren<ICardListLayoutProps>> = ({
  children,
  isNarrow,
  gridType = 'oneColumn',
  dataTestId,
  className,
}) => {
  return (
    <div
      className={clsx('card-list', {
        [`card-list_narrow card-list_${GRID_TYPE_TO_CLASS_NAME[gridType]}`]: isNarrow,
        className,
      })}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
